import axios from "axios";

import { INoContentResponse } from "@krea/shared/types/response";

export const selectLenderResponse = async (lenderResponseID: string) => {
  return axios.post<INoContentResponse>(
    `/api/v1/lender-response/${lenderResponseID}/select`,
  );
};

export const markAsEligibleForPayment = async (lenderResponseID: string) => {
  return axios.post<INoContentResponse>(
    `/api/v1/lender-response/${lenderResponseID}/mark-as-eligible-for-payment`,
  );
};

export const markSigningUrlClicked = async (lenderResponseID: string) => {
  return axios.post<INoContentResponse>(
    `api/v1/lender-responses/${lenderResponseID}/mark-signing-url-clicked`,
  );
};
